/* ============================================
   GLOMESH — Product Page JS
   Exact port from product-glomesh.liquid <script> + custom.js zoom.
   Cleaned: flat function structure, no deeply nested callbacks.
   ============================================ */

(function() {
  'use strict';

  /* ── Accordions ── */
  document.querySelectorAll('.g-pdp__accordion-trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var accordion = this.closest('.g-pdp__accordion');
      var isColours = accordion && accordion.classList.contains('g-pdp__accordion--colours');
      var content = this.nextElementSibling;
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var icon = this.querySelector('.g-pdp__accordion-icon');

      // Close others
      document.querySelectorAll('.g-pdp__accordion-trigger').forEach(function(other) {
        if (other !== trigger) {
          other.setAttribute('aria-expanded', 'false');
          if (other.nextElementSibling) other.nextElementSibling.style.display = 'none';
          var otherIcon = other.querySelector('.g-pdp__accordion-icon');
          if (otherIcon) otherIcon.style.transform = 'rotate(0deg)';
        }
      });

      this.setAttribute('aria-expanded', String(!expanded));
      content.style.display = expanded ? 'none' : 'block';
      icon.style.transform = expanded ? 'rotate(0deg)' : 'rotate(180deg)';

      // If opening colours, close the expandable section
      if (isColours) {
        var wrapper = document.getElementById('glomeshAccordions');
        var expandBtn = document.getElementById('glomeshExpand');
        if (wrapper && wrapper.classList.contains('is-open')) {
          wrapper.classList.remove('is-open');
          if (expandBtn) {
            expandBtn.setAttribute('aria-expanded', 'false');
            var eIcon = expandBtn.querySelector('.g-pdp__accordion-icon');
            if (eIcon) eIcon.style.transform = 'rotate(0deg)';
          }
        }
      }
    });
  });

  /* ── More Info expand/collapse ── */
  var expandBtn = document.getElementById('glomeshExpand');
  var accordionsWrapper = document.getElementById('glomeshAccordions');

  if (expandBtn && accordionsWrapper) {
    expandBtn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      var icon = this.querySelector('.g-pdp__accordion-icon');
      this.setAttribute('aria-expanded', String(!expanded));
      accordionsWrapper.classList.toggle('is-open');
      icon.style.transform = expanded ? 'rotate(0deg)' : 'rotate(180deg)';
    });
  }

  /* ── Dimensions toggle ── */
  function bindDimensionsToggle() {
    document.querySelectorAll('.g-pdp__dim-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var unit = this.dataset.unit;
        document.querySelectorAll('.g-pdp__dim-btn').forEach(function(b) { b.classList.remove('g-pdp__dim-btn--active'); });
        this.classList.add('g-pdp__dim-btn--active');
        document.querySelectorAll('.dim-cm').forEach(function(el) { el.style.display = unit === 'cm' ? '' : 'none'; });
        document.querySelectorAll('.dim-in').forEach(function(el) { el.style.display = unit === 'in' ? '' : 'none'; });
      });
    });
  }
  bindDimensionsToggle();

  /* ── Zoom overlay ── */
  var overlay = document.getElementById('glomeshZoomOverlay');
  var zoomImg = document.getElementById('glomeshZoomImage');
  var closeBtn = document.getElementById('glomeshZoomClose');
  var prevBtn = document.getElementById('glomeshZoomPrev');
  var nextBtn = document.getElementById('glomeshZoomNext');
  var images = document.querySelectorAll('.g-pdp__gallery-img');
  var currentIndex = 0;

  function showImage(idx) {
    currentIndex = idx;
    var src = images[idx].src;
    if (src.indexOf('width=') !== -1) src = src.replace(/width=\d+/, 'width=1800');
    zoomImg.src = src;
    zoomImg.alt = images[idx].alt;
  }

  function bindGalleryClicks() {
    images = document.querySelectorAll('.g-pdp__gallery-img');
    images.forEach(function(img, idx) {
      var wrapper = img.closest('.g-pdp__gallery-item');
      if (wrapper) {
        wrapper.addEventListener('click', function() {
          showImage(idx);
          overlay.classList.add('active');
          document.body.classList.add('no-scroll');
          setTimeout(function() { updateIndicator(zoomScale); }, 50);
        });
      }
    });
  }
  bindGalleryClicks();

  function closeZoom() {
    overlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
    resetZoom();
    resetOverlayZoom();
    hideIndicator();
  }

  closeBtn.addEventListener('click', closeZoom);
  prevBtn.addEventListener('click', function(e) { e.stopPropagation(); showImage((currentIndex - 1 + images.length) % images.length); resetZoom(); });
  nextBtn.addEventListener('click', function(e) { e.stopPropagation(); showImage((currentIndex + 1) % images.length); resetZoom(); });

  document.addEventListener('keydown', function(e) {
    if (!overlay.classList.contains('active')) return;
    if (e.key === 'Escape') closeZoom();
    if (e.key === 'ArrowLeft') { showImage((currentIndex - 1 + images.length) % images.length); resetZoom(); }
    if (e.key === 'ArrowRight') { showImage((currentIndex + 1) % images.length); resetZoom(); }
  });

  /* ── Desktop zoom: scroll-wheel + drag-to-pan ── */
  var isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var zoomScale = 1, zoomX = 0, zoomY = 0;
  var isDragging = false, didDrag = false;
  var dragStartX = 0, dragStartY = 0, dragOriginX = 0, dragOriginY = 0;

  /* Zoom indicator */
  var zoomIndicator = document.getElementById('glomeshZoomIndicator');
  var gziFill = document.getElementById('gziFill');
  var gziThumb = document.getElementById('gziThumb');
  var gziLevel = document.getElementById('gziLevel');

  function updateIndicator(scale) {
    if (!isDesktop || !zoomIndicator) return;
    var pct = ((scale - 1) / 1.5) * 100;
    if (gziFill) gziFill.style.height = pct + '%';
    if (gziThumb) gziThumb.style.bottom = pct + '%';
    if (gziLevel) gziLevel.textContent = scale.toFixed(1) + 'x';
    zoomIndicator.classList.add('visible');
  }

  function hideIndicator() {
    if (zoomIndicator) zoomIndicator.classList.remove('visible');
  }

  var zoomRAF = null;
  function applyZoom() {
    if (!zoomImg) return;
    if (zoomRAF) cancelAnimationFrame(zoomRAF);
    zoomRAF = requestAnimationFrame(function() {
      zoomImg.style.willChange = 'transform';
      zoomImg.style.transition = 'none';
      zoomImg.style.transform = 'translate3d(' + zoomX + 'px, ' + zoomY + 'px, 0) scale(' + zoomScale + ')';
      zoomImg.style.cursor = zoomScale > 1 ? 'grab' : 'default';
      updateIndicator(zoomScale);
    });
  }

  function resetZoom() { zoomScale = 1; zoomX = 0; zoomY = 0; applyZoom(); }

  if (isDesktop) {
    document.addEventListener('wheel', function(e) {
      if (!overlay || !overlay.classList.contains('active')) return;
      e.preventDefault();
      var delta = Math.abs(e.deltaY) > 50 ? (e.deltaY > 0 ? -0.15 : 0.15) : (e.deltaY > 0 ? -0.05 : 0.05);
      zoomScale = Math.min(Math.max(zoomScale + delta, 1), 2.5);
      if (zoomScale === 1) { zoomX = 0; zoomY = 0; }
      applyZoom();
    }, { passive: false, capture: true });

    document.addEventListener('mousedown', function(e) {
      if (!overlay || !overlay.classList.contains('active') || zoomScale <= 1) return;
      if (e.target.id === 'glomeshZoomPrev' || e.target.id === 'glomeshZoomNext' || e.target.id === 'glomeshZoomClose') return;
      isDragging = true; didDrag = false;
      dragStartX = e.clientX; dragStartY = e.clientY;
      dragOriginX = zoomX; dragOriginY = zoomY;
      zoomImg.style.cursor = 'grabbing';
      e.preventDefault();
    }, { capture: true });

    document.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      didDrag = true;
      zoomX = dragOriginX + (e.clientX - dragStartX);
      zoomY = dragOriginY + (e.clientY - dragStartY);

      // Clamp pan to image bounds
      if (zoomImg && zoomScale > 1) {
        var vw = window.innerWidth, vh = window.innerHeight;
        var nat = zoomImg.naturalWidth / zoomImg.naturalHeight;
        var rw, rh;
        if (vw / vh > nat) { rh = vh; rw = vh * nat; } else { rw = vw; rh = vw / nat; }
        var maxX = Math.max(0, (rw * zoomScale - vw) / 2);
        var maxY = Math.max(0, (rh * zoomScale - vh) / 2);
        zoomX = Math.max(-maxX, Math.min(maxX, zoomX));
        zoomY = Math.max(-maxY, Math.min(maxY, zoomY));
      }
      applyZoom();
    }, { capture: true });

    document.addEventListener('mouseup', function() {
      if (!isDragging) return;
      isDragging = false;
      if (zoomImg) zoomImg.style.cursor = zoomScale > 1 ? 'grab' : 'default';
    }, { capture: true });
  }

  /* ── Mobile zoom: pinch + swipe ── */
  var overlayZoomScale = 1, overlayPanX = 0, overlayPanY = 0;
  var pinchStartDist = 0, pinchStartScale = 1;
  var panStartX2 = 0, panStartY2 = 0, panOriginX2 = 0, panOriginY2 = 0;
  var touchAction = 'none';
  var touchStartX = 0, touchStartY = 0;

  function dist(t1, t2) { return Math.sqrt(Math.pow(t2.clientX - t1.clientX, 2) + Math.pow(t2.clientY - t1.clientY, 2)); }

  function applyOverlayZoom() {
    if (!zoomImg) return;
    zoomImg.style.transition = 'none';
    zoomImg.style.transform = 'translate(' + overlayPanX + 'px,' + overlayPanY + 'px) scale(' + overlayZoomScale + ')';
  }

  function resetOverlayZoom() {
    overlayZoomScale = 1; overlayPanX = 0; overlayPanY = 0;
    if (zoomImg) { zoomImg.style.transition = 'transform 0.2s ease'; zoomImg.style.transform = ''; }
  }

  document.addEventListener('touchstart', function(e) {
    if (!overlay || !overlay.classList.contains('active')) return;
    if (e.touches.length === 2) {
      e.preventDefault(); touchAction = 'pinch';
      pinchStartDist = dist(e.touches[0], e.touches[1]); pinchStartScale = overlayZoomScale;
    } else if (e.touches.length === 1) {
      if (overlayZoomScale > 1.05) {
        touchAction = 'pan';
        panStartX2 = e.touches[0].clientX; panStartY2 = e.touches[0].clientY;
        panOriginX2 = overlayPanX; panOriginY2 = overlayPanY;
      } else {
        touchAction = 'swipe';
        touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY;
      }
    }
  }, { passive: false });

  document.addEventListener('touchmove', function(e) {
    if (!overlay || !overlay.classList.contains('active')) return;
    if (e.touches.length === 2) {
      e.preventDefault(); touchAction = 'pinch';
      overlayZoomScale = Math.min(Math.max(pinchStartScale * (dist(e.touches[0], e.touches[1]) / pinchStartDist), 1), 4);
      if (overlayZoomScale <= 1.05) { overlayPanX = 0; overlayPanY = 0; }
      applyOverlayZoom();
    } else if (e.touches.length === 1 && touchAction === 'pan') {
      e.preventDefault();
      overlayPanX = panOriginX2 + (e.touches[0].clientX - panStartX2);
      overlayPanY = panOriginY2 + (e.touches[0].clientY - panStartY2);
      applyOverlayZoom();
    }
  }, { passive: false });

  document.addEventListener('touchend', function(e) {
    if (!overlay || !overlay.classList.contains('active')) return;
    if (touchAction === 'swipe' && e.changedTouches.length === 1) {
      var diffX = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diffX) > Math.abs(touchStartY - e.changedTouches[0].clientY) && Math.abs(diffX) > 50) {
        resetOverlayZoom();
        (diffX > 0 ? nextBtn : prevBtn).click();
      }
    }
    if ((touchAction === 'pinch' || touchAction === 'pan') && overlayZoomScale <= 1.05) resetOverlayZoom();
    if (e.touches.length === 0) touchAction = 'none';
  }, { passive: true });

  /* Click on zoom image: close if not zoomed, reset if zoomed */
  document.addEventListener('click', function(e) {
    if (!overlay || !overlay.classList.contains('active')) return;
    if (didDrag) { didDrag = false; e.stopPropagation(); e.preventDefault(); return; }
    if (e.target === zoomImg) {
      if (zoomScale > 1 || overlayZoomScale > 1.05) { resetZoom(); resetOverlayZoom(); }
      else closeZoom();
      e.stopPropagation(); e.preventDefault();
    }
  }, { capture: true });

  /* ── Colour swap (AJAX, no page reload) ── */
  function bindColourClicks() {
    document.querySelectorAll('.g-pdp__colour-item').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var url = this.getAttribute('href');
        if (!url) return;

        // Highlight active
        document.querySelectorAll('.g-pdp__colour-item').forEach(function(i) { i.classList.remove('g-pdp__colour-item--active'); });
        this.classList.add('g-pdp__colour-item--active');

        // Collapse expandable section
        var wrapper = document.getElementById('glomeshAccordions');
        var expBtn = document.getElementById('glomeshExpand');
        if (wrapper && wrapper.classList.contains('is-open')) {
          wrapper.classList.remove('is-open');
          if (expBtn) {
            expBtn.setAttribute('aria-expanded', 'false');
            var eIcon = expBtn.querySelector('.g-pdp__accordion-icon');
            if (eIcon) eIcon.style.transform = 'rotate(0deg)';
          }
        }

        fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=glomesh-product&_=' + Date.now(), { cache: 'no-store' })
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');

            // Swap gallery
            swap('.g-pdp__gallery', doc);
            // Swap header
            swap('.g-pdp__header', doc);
            // Swap the entire form / BIS area (handles ADD ↔ PRE-ORDER ↔ NOTIFY ME)
            var oldForm = document.querySelector('.g-pdp__panel form[action*="/cart/add"]');
            var oldBis = document.querySelector('.g-pdp__bis');
            var newForm = doc.querySelector('.g-pdp__panel form[action*="/cart/add"]');
            var newBis = doc.querySelector('.g-pdp__bis');
            var oldEl = oldForm || oldBis;
            var newEl = newForm || newBis;
            if (oldEl && newEl) {
              oldEl.outerHTML = newEl.outerHTML;
            }
            // Swap accordion contents (skip first which is colours)
            var newAcc = doc.querySelectorAll('.g-pdp__accordion-content');
            var oldAcc = document.querySelectorAll('.g-pdp__accordion-content');
            newAcc.forEach(function(nd, i) { if (oldAcc[i] && i > 0) oldAcc[i].innerHTML = nd.innerHTML; });

            // Mark active colour
            document.querySelectorAll('.g-pdp__colour-item').forEach(function(item) {
              item.classList.toggle('g-pdp__colour-item--active', item.getAttribute('href') === url);
            });

            history.replaceState({}, '', url);
            document.title = doc.title;
            window.scrollTo(0, 0);

            bindGalleryClicks();
            bindDimensionsToggle();
            bindAddToCart();
            bindBIS();

            // Update Stoq/Restock Rocket
            var newHandle = url.split('/products/')[1];
            if (newHandle && window._RestockRocket) {
              fetch('/products/' + newHandle + '.js')
                .then(function(r) { return r.json(); })
                .then(function(p) {
                  window._RestockRocketConfig.product = p;
                  window._RestockRocketConfig.selected_variant_id = p.variants[0].id;
                  window._RestockRocketConfig.selected_variant_available = p.variants[0].available;
                  _RestockRocket.updateAddToCartForms();
                });
            }
          })
          .catch(function() { window.location.href = url; });
      });
    });
  }
  bindColourClicks();

  function swap(selector, doc) {
    var newEl = doc.querySelector(selector);
    var oldEl = document.querySelector(selector);
    if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
  }

  /* ── Add to cart ── */
  function bindAddToCart() {
    document.querySelectorAll('.g-pdp__panel form[action*="/cart/add"] .g-pdp__atb').forEach(function(btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var btnText = btn.textContent.trim();
        if (btnText !== 'ADD' && !btnText.startsWith('PRE-ORDER')) {
          return;
        }
        var form = btn.closest('form');
        if (!form) return;
        btn.style.opacity = '0.4';
        btn.style.pointerEvents = 'none';
        if (typeof window.addToCart === 'function') {
          window.addToCart(new FormData(form)).then(function() {
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
          }).catch(function() {
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
          });
        }
      });
    });

    // Safety net: prevent default form submission (handled by click handler above)
    document.querySelectorAll('.g-pdp__panel form[action*="/cart/add"]').forEach(function(form) {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', function(e) {
        e.preventDefault();
      });
    });
  }
  bindAddToCart();

  /* ── Bind back-in-stock (Klaviyo) NOTIFY ME listeners ── */
  function bindBIS() {
    var trigger = document.getElementById('bisTrigger');
    var bisForm = document.getElementById('bisForm');
    var bisEmail = document.getElementById('bisEmail');
    var bisSubmit = document.getElementById('bisSubmit');
    var bisThanks = document.getElementById('bisThanks');
    var bisWrap = document.getElementById('glomeshBIS');
    if (!trigger || !bisForm || trigger.dataset.bound) return;
    trigger.dataset.bound = 'true';
    trigger.addEventListener('click', function() {
      if (bisForm.style.display === 'flex') {
        bisForm.style.display = 'none';
        trigger.textContent = 'NOTIFY ME WHEN AVAILABLE';
      } else {
        bisForm.style.display = 'flex';
        trigger.textContent = 'CLOSE';
        bisEmail.focus();
      }
    });
    bisSubmit.addEventListener('click', function() {
      var email = bisEmail.value;
      if (!email) return;
      var variantId = bisWrap ? bisWrap.dataset.variantId : '';
      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=WnZQJZ', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
            }
          }
        })
      }).then(function() {
        bisForm.style.display = 'none';
        trigger.style.display = 'none';
        bisThanks.style.display = 'block';
        setTimeout(function() {
          bisThanks.style.display = 'none';
          trigger.textContent = 'WE\'LL LET YOU KNOW';
          trigger.style.display = 'block';
          trigger.style.opacity = '0.5';
          trigger.style.pointerEvents = 'none';
          bisEmail.value = '';
        }, 3000);
      });
    });
  }
  bindBIS();

  /* ── Fix button state (bypasses CDN cache) ── */
  var pdpEl = document.querySelector('.g-pdp[data-product-id]');
  if (pdpEl) {
    fetch(window.location.pathname + '?section_id=glomesh-product&_=' + Date.now(), { cache: 'no-store' })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newBtn = doc.querySelector('.g-pdp__atb');
        var newBis = doc.querySelector('.g-pdp__bis');
        var oldBtn = document.querySelector('.g-pdp__atb');
        var oldForm = oldBtn ? oldBtn.closest('form') : null;
        var oldBis = document.querySelector('.g-pdp__bis');

        if (newBis && oldForm) {
          oldForm.outerHTML = newBis.outerHTML;
          bindBIS();
        } else if (newBtn && oldBis) {
          var newForm = newBtn.closest('form');
          if (newForm) oldBis.outerHTML = newForm.outerHTML;
          bindAddToCart();
        }
      });
  }

  /* ── Scroll hint (mobile) ── */
  if (window.innerWidth < 750) {
    var hint = document.getElementById('glomeshScrollHint');
    if (hint) {
      setTimeout(function() { hint.classList.add('hidden'); }, 5000);
      window.addEventListener('scroll', function() { hint.classList.add('hidden'); }, { once: true, passive: true });
    }
  }

  /* ── Mobile: hide info panel when footer visible ── */
  if (window.innerWidth < 750) {
    var infoPanel = document.getElementById('glomeshInfo');
    var pdpWrap = document.querySelector('.g-pdp--mm');
    var footer = document.querySelector('.g-footer');
    if (infoPanel && footer) {
      infoPanel.style.transition = 'transform 0.3s ease';
      window.addEventListener('scroll', function() {
        var footerRect = footer.getBoundingClientRect();
        var nearFooter = footerRect.top < window.innerHeight;
        if (pdpWrap) pdpWrap.classList.toggle('is-near-footer', nearFooter);
        /* Don't override if user has minimised via tab */
        if (pdpWrap && pdpWrap.classList.contains('is-panel-hidden')) {
          infoPanel.style.transform = '';
          return;
        }
        infoPanel.style.transform = nearFooter ? 'translateY(150%)' : 'translateY(0)';
      }, { passive: true });
    }
  }

})();
